import type { GeneratorStatusReviewExplanationBasis } from "generated-graphql/graphql";

import {
  compareGeneratorReviewEvents,
  isGeneratorReviewDisposition,
} from "encamp-shared/src/waste/generatorFindings";

export type ReviewEvent = {
  id: string;
  eventType: string;
  createdAt: string;
  actorId?: string | null;
  actorName?: string | null;
  note?: string | null;
  explanation?: {
    basis: GeneratorStatusReviewExplanationBasis;
    message: string;
  } | null;
  comparison?: string | null;
};

export function chronologicalReviewEvents(events: readonly ReviewEvent[]) {
  return [...events].sort(compareGeneratorReviewEvents);
}

export function reviewLifecycle(events: readonly ReviewEvent[]) {
  return chronologicalReviewEvents(events).filter((event) =>
    isGeneratorReviewDisposition(event.eventType)
  );
}
